import { render, staticRenderFns } from "./sponsor-worden.vue?vue&type=template&id=499ea86a&"
import script from "./sponsor-worden.vue?vue&type=script&lang=js&"
export * from "./sponsor-worden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports